export const ACTION_BAR_IDS = [
  'profile',
  'community',
  'add-activity',
  'challenges',
];
